import { axios, reqInterceptor, reqErr, repInterceptor, repErr } from './axios'
import { baseUrl } from 'api/config'

const options = {
  baseURL: baseUrl,
  withCredentials: true,
  timeout: 10000, // 请求超时时间
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  }
}
const service = axios.create(options)
service.interceptors.request.use(reqInterceptor, reqErr)
service.interceptors.response.use(repInterceptor, repErr)

export default service